module.exports = __webpack_public_path__ + "static/media/Lato-Italic.7582e823.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Lato/Lato-Italic.ttf
// module id = 295
// module chunks = 0